import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-city-survey',
  templateUrl: './city-survey.component.html',
  styleUrls: ['./city-survey.component.css']
})
export class CitySurveyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/city-survey/city-survey.component.ts